"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InspirationIndexItemAbstract = exports.InspirationItemType = void 0;
const base_1 = require("../base");
var InspirationItemType;
(function (InspirationItemType) {
    InspirationItemType["Inspiration"] = "inspirationpage";
})(InspirationItemType || (exports.InspirationItemType = InspirationItemType = {}));
class InspirationIndexItemAbstract extends base_1.BaseIndexItemAbstract {
    constructor() {
        super(...arguments);
        this.type = InspirationItemType.Inspiration;
        this.author = "";
        this.publishDate = 0;
    }
}
exports.InspirationIndexItemAbstract = InspirationIndexItemAbstract;
